import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { IframeNodeFrontend } from "./IframeNodeFrontend";

export const IframeExtensionFrontend = Node.create({
  name: "iframe",

  group: "block",

  atom: true,

  draggable: false, // Not draggable on frontend

  addAttributes() {
    return {
      url: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-url"),
        renderHTML: (attributes) => {
          return {
            "data-url": attributes.url,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-iframe-node]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", { ...HTMLAttributes, "data-iframe-node": "" }, 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(IframeNodeFrontend);
  },
});
